import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { useSingleObjetivo } from "../../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";
import { iDataIndicador } from "../../../../interfaces/SuperAdmin/Pages/iDataIndicador";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";

interface Props {
  indicador: iDataIndicador;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const IndicadoresRow: React.FC<Props> = ({
  indicador,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombre } = indicador;
  const { handleEditIndicador } = useSingleObjetivo();

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(indicador.id_indicador)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 500 }}>
        {nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEditIndicador(indicador)}
        >
          <Tooltip title="Editar indicador">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
